export const faqsData = [
  {
    category: "Admissions & Consultations",
    questions: [
      {
        question: "How can I consult UMED or schedule an initial psychiatric assessment?",
        answer: "You can schedule a confidential consultation by calling our dedicated hospital helpline (+91 9226999705), reaching out via WhatsApp, or submitting the consultation request form on our website. Our clinical triage team will guide you through immediate next steps."
      },
      {
        question: "How does the inpatient admission process work at UMED?",
        answer: "Admissions begin with an in-depth preliminary psychiatric evaluation by our consultant psychiatrist to determine clinical necessity. Following medical clearance and orientation with family members, the patient is admitted to a suitable accommodation room under round-the-clock nursing supervision."
      },
      {
        question: "Do you handle psychiatric emergencies and acute admissions 24/7?",
        answer: "Yes. Our emergency psychiatric intake and nursing teams are on duty 24 hours a day, 365 days a year to manage acute behavioral crises, severe substance intoxication, and psychotic episodes safely and compassionately."
      }
    ]
  },
  {
    category: "Care & Daily Living",
    questions: [
      {
        question: "What should a patient bring during an inpatient stay at UMED?",
        answer: "Patients should bring 4–5 sets of comfortable, modest daily clothing, essential toiletries (non-glass containers), previous medical records/prescriptions, and valid government identification. Prohibited items include sharp objects, mirrors, cords, belts, outside medications, and non-prescribed substances to ensure maximum safety."
      },
      {
        question: "How are privacy and patient confidentiality protected?",
        answer: "UMED adheres to strict confidentiality standards. All medical records, clinical notes, and identity details are strictly confidential and never shared with third parties without explicit legal or guardian authorization."
      },
      {
        question: "What does psychiatric rehabilitation involve on a daily basis?",
        answer: "A typical rehabilitation day incorporates structured wake-up routines, yoga/mindfulness, individual psychotherapy, group cognitive remediation, occupational craft and art sessions, nutritious shared meals, outdoor recreation, and family communication hours."
      }
    ]
  },
  {
    category: "Family & Aftercare",
    questions: [
      {
        question: "How can families actively participate in the patient's recovery?",
        answer: "We strongly believe family involvement is vital for sustainable recovery. We host weekly psychoeducational sessions, guided family counseling, and scheduled visiting hours where family members learn how to support their loved one without emotional burnout."
      },
      {
        question: "What happens after discharge from UMED?",
        answer: "Prior to discharge, our team crafts a comprehensive Relapse Prevention and Aftercare Plan including medication schedules, home routine recommendations, scheduled outpatient consultations, and continuous emergency support access."
      }
    ]
  }
];
